<div id="dvSignUp" class="sign-up-container">
  <div id="dvOpenSignUp" class="sign-up-container-header" (click)="OpenSignUp($event);">
    <p class="signup-header-text">Create a Survey</p>
    <span class="slide-up" style="display: block;"></span>
    <span class="slide-down" style="display: none;"></span>
  </div>
  <div class="sign-up-container-body" [style.display]="isUpButton? 'block': 'none'">
    <p>Sign up with your email address</p>
    <input name="txtEmailId" type="text" maxlength="50" id="txtEmailId" class="signupEmail"
      (keypress)="ProcessSignUpOnEnter($event.keyCode)" [(ngModel)]="userEmail">
    <input type="button" (click)="ProcessSignUp()" class="signupSubmit" value="Get Started" id="submit1">

    <div style="margin:2% 0 0 6.5%;">
      <div class="borderLines"></div>
      <div class="orText">or sign up with</div>
      <div class="borderLines"></div>
      <div class="clr"></div>
    </div>

    <!-- Added SignUp Images -->
    <a target="_google" href="javascript:void(0)" (click)="SignInGoogle()" class="floatL">
      <div style="width:60px;" class="fbandGoogleButtons google-signfirst"></div>
    </a>
    <a target="_facebook" (click)="SignInFacebook()" href="javascript:void(0);" class="floatL" id="A6">
      <div style="width:60px;" class="bandGoogleButtons">
      </div>
    </a>
  </div>
</div>
<div id="overs1" class="modal"
  style="z-index:9999;position:absolute;width:450px;display:none;transform: translate(-50%, -50%);-transform: translate(-50%, -50%); top: 50%; left: 50%;border: none;border-radius: 3px; padding: 10px 30px 25px;">
  <p id="error_mess" style="font-size:16px;font-family: Proxima N W01 Smbd">
  </p>
  <a href="javascript:void(0);" id="a_cancel" style="display:none;" class="modalClose btn-cancel-account"
    (click)="CloseModal()">Cancel</a>
  <input type="button" id="btnLog" class="signupSubmit1" value="Login" style="display:none;" (click)="RedirectUrl()" />
  <input type="button" id="btnOk" class="signupSubmit1" value="Ok" style="display:none;margin-left:165px;"
    (click)="CloseModal()" />
</div>
<div id="fadeDiv1"
  style="width:100%;display:none;height:1000px;position:fixed;z-index:1003;top:0px;left:0px;background:#646464;opacity:.7;filter:alpha(opacity=70);">
</div>